import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/faqs/components/FAQContent.tsx");
